import axios, { AxiosInstance } from "axios";
import { store } from "store/store";
import { RootState } from "store/types";

export function getApi(fetchURL: string) {
  const api: AxiosInstance = axios.create({
    baseURL: fetchURL,
  });

  api.interceptors.request.use(async (config: any) => {
    const state: RootState = store.getState();
    const tokenResponse = state.auth.accessToken;

    if (tokenResponse) {
      config.headers.Authorization = "Bearer " + tokenResponse;
    }
    return config;
  });

  return api;
}
